<template>
  <v-container fluid v-if="location" grid-list-lg>
    <TitleBar :title="location.name" />
    <v-layout column>
      <v-flex xs12>
        <v-card flat class="outlined rounded-border">
          <CardToolbar :title="$t('pageHeader.location')" :isModal="false">
            <v-btn color="pink" dark round :href="`${terminalURL}/login/location?code=${location.code}`"
              target="_blank">
              Open Terminal
            </v-btn>
          </CardToolbar>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <div class="font-weight-bold">{{ location.Address.addressLine1 }}</div>
                <div>{{ location.Address.addressLine2 }}</div>
                <div>{{ location.Address.city }}</div>
                <div>{{ location.Address.State.name }}</div>
                <div>{{ location.Address.postalCode }}</div>
                <div>{{ location.Address.phoneNumber }}</div>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink>
                <v-layout column>
                  <v-flex>
                    <DateTimePicker :defaultRange="dateTime.range" :range="true" v-model="dateTime"
                      :initStartDate="start" :initEndDate="end" @submit="getLocationSales()" />
                  </v-flex>
                  <v-flex>
                    <div class="text-xs-right">
                      From:
                      <span class="font-weight-medium">{{
                        dateTime.start | moment('LLLL')
                        }}</span>
                    </div>
                    <div class="text-xs-right">
                      To:
                      <span class="font-weight-medium">{{
                        dateTime.end | moment('LLLL')
                        }}</span>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card flat class="outlined rounded-border">
          <CardToolbar title="Sales Stacks" :isModal="false">
          </CardToolbar>
          <v-card-text>
            <SaleBaseTile ref="saleBaseTile" :dateTime="dateTime" :id="location.id" />
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card flat class="outlined rounded-border">
          <v-card-text>
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-content>
                <div slot="header">Subscription</div>
                <v-card lazy v-if="subscription">
                  <v-card-text>
                    <div v-if="subscription.plan">
                      <span class="font-weight-medium">Plan:</span>
                      {{ subscription.plan.nickname }} <br />
                      <span class="font-weight-medium">Amount:</span>
                      {{ (subscription.plan.amount / 100) | currency }} <br />
                      <span class="font-weight-medium">Interval:</span>
                      {{ subscription.plan.interval }} <br />
                    </div>
                    <div v-else-if="subscription.items.count > 1">
                      <span>Active Plans</span>
                      <div v-for="item in subscription.items.data" :key="item.id" class="ma-2">
                        <span class="font-weight-medium">Plan:</span> {{ item.plan.name }}
                        <br />
                        <span class="font-weight-medium">Amount:</span>
                        {{ (item.plan.amount / 100) | currency }} <br />
                        <span class="font-weight-medium"></span> {{ item.plan.interval }} <br />
                      </div>
                    </div>
                    <span class="font-weight-medium">Subscribed ID:</span>
                    {{ subscription.id }} <br />
                    <span class="font-weight-medium">Subscribed Since:</span>
                    {{ $moment.unix(subscription.start_date).format('MM/DD/YY') }} <br />
                    <span class="font-weight-medium">Status:</span> {{ subscription.status }}
                    <br />
                    <span class="font-weight-medium">Renewal:</span>
                    {{
                      `${subscription.billing === 'charge_automatically'
                        ? 'Auto-charge'
                        : 'Manual'
                      }`
                    }}
                    <br />
                    <span class="font-weight-medium">Current Billing Cycle:</span>
                    {{ $moment.unix(subscription.current_period_start).format('L') }} -
                    {{ $moment.unix(subscription.current_period_end).format('L') }}
                    <br />
                    <span v-if="subscription.trial_end">Trial Ends: {{ $moment.unix(subscription.trial_end).format('L')
                      }}
                      <br /></span>
                  </v-card-text>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex shrink>
                        <update-plan :location="location" v-on:updated="loadSubscription"></update-plan>
                      </v-flex>
                      <v-flex shrink>
                        <update-payment-button :locationId="this.location.id"
                          :defaultCardId="subscription.default_source"
                          v-on:update="loadSubscription"></update-payment-button>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
                <v-progress-linear indeterminate color="white" class="mb-0" v-else></v-progress-linear>
              </v-expansion-panel-content>
              <v-expansion-panel-content>
                <div slot="header">Employees</div>
                <v-card>
                  <EmployeeList :LocationId="location.id" :hideHeader="true" :hideCreate="true"></EmployeeList>
                </v-card>
              </v-expansion-panel-content>
              <v-expansion-panel-content>
                <div slot="header">Settings</div>
                <v-card>
                  <Settings :LocationId="location.id"></Settings>
                </v-card>
              </v-expansion-panel-content>
              <v-expansion-panel-content>
                <div slot="header">Notifications</div>
                <Notifications :LocationId="location.id" :location="location"></Notifications>
              </v-expansion-panel-content>
              <v-expansion-panel-content>
                <div slot="header">Reports</div>
                <v-card>
                  <Reports :LocationId="location.id" :location="location" :Time="dateTime"></Reports>
                </v-card>
              </v-expansion-panel-content>
              <!-- <v-expansion-panel-content v-if="getLocationIntegration">
                <div slot="header">Expense</div>
                <v-card>
                  <Expense :locationIntegration="locationIntegration" :LocationId="location.id" :location="location">
                  </Expense>
                </v-card>
              </v-expansion-panel-content> -->
            </v-expansion-panel>
          </v-card-text>
        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import locationService from '@/modules/Location/service.js'
import UpdatePaymentButton from '../components/UpdatePayment'
import UpdatePlan from '../components/UpdatePlan'
import EmployeeList from '../../Employee/components/List'
import Settings from '../components/Settings'
import Reports from '../components/Reports'
// import Expense from '@/modules/Location/components/Expense/index.vue'
import Notifications from '../components/Notifications'
import DateTimePicker from '@/components/DateTimePicker'
import SaleBaseTile from '@/modules/Location/components/SaleBase.vue'

export default {
  name: 'location-view-profile',
  components: {
    UpdatePaymentButton,
    UpdatePlan,
    EmployeeList,
    Settings,
    Reports,
    SaleBaseTile,
    Notifications,
    // Expense,
    DateTimePicker,
  },
  data() {
    return {
      start: this.$moment().startOf('day'),
      end: this.$moment().endOf('day'),
      dateTime: {
        range: 'thisMonth',
        start: this.$moment()
          .startOf('day')
          .toISOString(),
        end: this.$moment()
          .endOf('day')
          .toISOString(),
      },
      terminalURL: process.env.VUE_APP_TERMINALURL,
      location: null,
      Reports: {
        Sales: null,
      },
      subscription: null,
      isLoading: true,
      locationIntegration: false,
    }
  },
  async created() {
    await this.loadLocation()
    this.getTerminalExpense()
    this.$Progress.start()
    this.getLocationSales()

    this.loadSubscription()
  },
  computed: {
    getLocationIntegration() {
      return this.locationIntegration
    },
    cashInHand() {
      return this.Reports.Sales.cash.total - this.Reports.Sales.Expense.total
    },
    startDateFormatted() {
      if (this.startDatePicker.date) {
        console.log(this.startDatePicker.date)
        return this.$moment(this.startDatePicker.date).format('MM/DD/YYYY')
      }
      return null
    },
    endDateFormatted: {
      get() {
        if (this.endDatePicker.date) {
          return this.$moment(this.endDatePicker.date).format('MM/DD/YYYY')
        }
        return null
      },
      set(val) {
        return (this.endDatePicker.date = null)
      },
    },
    ...mapGetters('integration', ['locationModules']),
  },
  methods: {
    getLocationSales() {
      this.isLoading = true
      this.$Progress.start()
      locationService.Reports.getLocationSales({
        start: this.dateTime.start,
        end: this.dateTime.end,
        // today: true,
        LocationId: this.location.id,
      }).then(response => {
        this.$Progress.finish()
        this.Reports.Sales = response.data.report
        this.isLoading = false
      })
    },
    async getTerminalExpense() {
      locationService
        .getIntegrationByLocation(this.location.id, {
          module: 'terminalExpense',
        })
        .then((locationIntegration) => {
          const [integration] = locationIntegration.data;
          if (integration) {
            this.locationIntegration = integration;
          }
        })
    },

    loadLocation() {
      if (!this.$route.params || !this.$route.params.id) return this.$router.push('/location')
      const { id } = this.$route.params
      this.$Progress.start()
      return locationService
        .getbyId(id)
        .then((response) => {
          console.log('location', response.data)
          this.$Progress.finish()
          this.isLoading = false
          this.location = response.data
        })
        .catch(error => {
          this.$router.push('/location')
        })
    },
    loadSubscription() {
      return locationService.Billing.getSubscription(this.location.id)
        .then(response => {
          console.log('sub', response.data)
          this.subscription = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>
